import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import moment from 'moment'
import { OrderTrackingService } from '../../order-tracking/order-tracking.service'
import { DatePipe } from '@angular/common'
import { DateFormats } from '../../../shared/components/date-range-picker/date-range-picker.component'
import { CommonService } from '../../../shared/services/common.service'
import { AuthService } from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Component({
  standalone: false,

  selector: 'vs-loggedin-home-page',
  templateUrl: './loggedin-home-page.component.html',
  styleUrls: ['./loggedin-home-page.component.scss'],
})
export class LoggedinHomePageComponent implements OnInit {
  monthDifference: number = 6
  currentUser: any
  currentPage = 0
  pageSize = 50
  sortBy = 'OrderDsc'
  dateRange = false
  searchTerm = ''
  statusFilter = ''
  serialNo = ''
  toDate: DateFormats = new DateFormats()
  public fromMaxDate
  public fromMax
  getMonths$: Observable<any>
  userDetails$: Observable<any>
  user$: Observable<any>
  STORAGE_KEY = 'recent_searches'
  recentSearchUserData = []
  userUid: any
  //userSapBlocked: boolean = false

  constructor(
    private router: Router,
    private commonService: CommonService,
    public orderTrackingService: OrderTrackingService,
    public datepipe: DatePipe,
    private auth: AuthService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
    this.userDetails$ = this.getCustomerData()
    this.getMonths$ = this.orderTrackingService.getConfigMonth()
    this.getMonths$.subscribe((success: any) => {
      this.monthDifference = parseInt(success)
      this.fromMax = new Date()
      this.fromMaxDate = new Date()
      this.fromMaxDate = this.fromMax.setMonth(
        this.fromMax.getMonth() - this.monthDifference
      )
      this.commonService.getUserData().subscribe((user) => {
        if (user) {
          this.currentUser = user
          this.getOrderlist()
        }
      })
    })

    this.userDetails$.subscribe((res) => {
      this.userUid = res.uid;
      //this.userSapBlocked = (res?.orgUnit?.sapBlocked == "true") ? true : false;
      this.recentSearchUserData = this.getRecentSearches(this.userUid);
    })
  }

  getCustomerData() {
    const params = ['users', 'current', 'myprofile']
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData(apiUrl)
  }
  getOrderlist() {
    const formattedFromDate = this.datepipe.transform(
      this.fromMaxDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    this.orderTrackingService
      .getOrders(
        this.currentUser.uid,
        this.searchTerm,
        this.statusFilter,
        this.dateRange,
        formattedFromDate,
        formattedToDate,
        this.currentPage,
        this.pageSize,
        this.sortBy
      )
      .subscribe((res: any) => {})
  }

  getLastLogin(dateString) {
    return moment(dateString).format('MMMM Do, YYYY')
  }
  getTodaysDate() {
    // const todaysDate = new Date();
    return moment(new Date()).format('MMMM Do, YYYY')
  }

  getAllRecentData() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  }

  saveRecentSearch(term: string, userId: string): void {
    if (!term || !userId) return;
  
    const allData = this.getAllRecentData();
    let userSearches = allData[userId] || [];
    userSearches = [term, ...userSearches.filter((s: string) => s !== term)].slice(0, 8);  
    allData[userId] = userSearches;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(allData));
  }

  getRecentSearches(userId: string): string[] {
    if (!userId) return [];
    const allData = this.getAllRecentData();
    return allData[userId] || [];
  }

  setRecentSearchInput(searchInput: string){
    this.serialNo = searchInput;
  }

  public keyUp(str, event){
    if(event.keyCode === 13){
      this.serialNo = str.value;
      if(str.value.length > 3){
        this.saveRecentSearch(str.value, this.userUid);
        this.router.navigate(["welcome-package/bom/", str.value]);
      }
    }
  }

  public modelChange(str): void {
    this.serialNo = str.value;
    if(str.value.length > 3){
      this.saveRecentSearch(str.value, this.userUid);
      this.router.navigate(["welcome-package/bom/", str.value]);
    }
  }
}
